/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Valid_ToInputs */

const en_reference_field_valid_to = /** @type {(inputs: Reference_Field_Valid_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid to`)
};

/**
* | output |
* | --- |
* | "Valid to" |
*
* @param {Reference_Field_Valid_ToInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_valid_to = /** @type {((inputs?: Reference_Field_Valid_ToInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Valid_ToInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_valid_to(inputs)
});